// extracted by mini-css-extract-plugin
module.exports = {"loadingBar":"lead_loadingBar__OmpXK","leadGradient":"lead_leadGradient__C0_6F","spin":"lead_spin__40KTQ"};